const BLOCK = 'BLOCK';
const HIDE = 'HIDE';
const SHOW = 'SHOW';

export const summaryVisibilityOptions = {
  BLOCK,
  HIDE,
  SHOW,
};
